/**
 * Service Worker registration.
 *
 * Registered only in production builds — in dev, Vite's HMR and a caching SW
 * fight each other. The SW (public/sw.js) is served from the site root so its
 * scope covers the whole app.
 */
export function registerServiceWorker(): void {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
  // import.meta.env.PROD is true only in `vite build` output.
  if (!(import.meta as any).env?.PROD) return;

  // When a newly activated SW *replaces* an existing one (a deploy that bumped
  // the cache version), reload once so the page runs a fresh, consistent set of
  // chunks instead of a stale/mixed cache. Skipped on first visit (no prior
  // controller) and guarded against reload loops.
  const hadController = !!navigator.serviceWorker.controller;
  let reloading = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!hadController || reloading) return;
    reloading = true;
    window.location.reload();
  });

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(
      (reg) => {
        // When a new SW is found and installed alongside an existing one, ask it
        // to take over immediately so users get fresh bundles without a manual
        // hard-reload.
        reg.addEventListener('updatefound', () => {
          const installing = reg.installing;
          if (!installing) return;
          installing.addEventListener('statechange', () => {
            if (installing.state === 'installed' && navigator.serviceWorker.controller) {
              reg.waiting?.postMessage('SKIP_WAITING');
            }
          });
        });
      },
      () => {
        /* registration failed — app still works, just without offline/caching */
      }
    );
  });
}
